import { hashEmail } from '../utils/cryptoUtils'
import { sendGtmEvent } from './gtmUtils'

type TrackSignUpEventProps = {
  email: string
  emailList: string
  section: string
  has_provided_phone_number: boolean
}

export const trackSignupEvent = ({ email, section, emailList, has_provided_phone_number }: TrackSignUpEventProps) => {
  const event = {
    event: 'sign_up',
    user_id: hashEmail(email),
    section: section,
    email_list: emailList,
    phone_provided: has_provided_phone_number,
  }

  sendGtmEvent(event)
}
